import React, { FunctionComponent } from 'react';

import { closeCurrentPopup } from '@paragon/popup-state';
import { formatAsNaturalLanguageList, naturalSortByProperty } from '@paragon/utilities';

import { deleteTrussGroups } from '../../store/actions/deletionActions';
import { ParentTrussGroupDeleteConfirmationProps } from '../../store/actions/popupActions';
import { useAppDispatch, useAppSelector } from '../hooks';
import { ConfirmDialog } from './ConfirmDialog';

export const ParentTrussGroupDeleteConfirmDialog: FunctionComponent<ParentTrussGroupDeleteConfirmationProps> = ({
  parentTrussGroupGuidsBeingDeleted,
  childTrussGroupsWhichWillBeCascadedDeleted,
}) => {
  const dispatch = useAppDispatch();
  const trussGroups = useAppSelector((state) => state.trussGroups);
  const openContext = useAppSelector((state) => state.application.openContext);
  if (openContext?.type !== 'project') throw new Error('Project not active');
  const projectGuid = openContext.projectGuid;

  const parentTrussGroupNames = formatAsNaturalLanguageList(
    naturalSortByProperty(
      parentTrussGroupGuidsBeingDeleted.map((guid) => trussGroups[guid]?.name ?? 'unknown'),
      (name) => name,
    ),
    'and',
  );
  const childTrussGroupNames = formatAsNaturalLanguageList(
    naturalSortByProperty(
      childTrussGroupsWhichWillBeCascadedDeleted.map((guid) => trussGroups[guid]?.name ?? 'unknown'),
      (name) => name,
    ),
    'and',
  );
  const message = `Deleting parent Truss Group${
    parentTrussGroupGuidsBeingDeleted.length !== 1 ? 's:' : ''
  } ${parentTrussGroupNames} will also delete the following Truss Group${
    childTrussGroupsWhichWillBeCascadedDeleted.length !== 1 ? 's' : ''
  }: ${childTrussGroupNames}.`;

  return (
    <ConfirmDialog
      open
      title="Confirm Delete"
      message={message}
      onClose={async (confirmed) => {
        dispatch(closeCurrentPopup());
        if (confirmed) {
          await dispatch(
            deleteTrussGroups(
              projectGuid,
              parentTrussGroupGuidsBeingDeleted.concat(childTrussGroupsWhichWillBeCascadedDeleted),
            ),
          );
        }
      }}
    />
  );
};
